<template>
	<v-app theme="light" style="background-color: #eeeeee">
		<nav-bar-supplier-performance />

		<VMain>
			<breadcrumbs />
			<v-container>
				<v-row class="contentRow" align="center">
					<v-col>
						<h1>Supplier Performance</h1>
					</v-col>
				</v-row>

				<v-card class="supplier-performance-shell white" elevation="2">
					<nav class="supplier-performance-nav main-nav">
						<ul>
							<li>
								<router-link :to="{ name: 'Supplier Performance' }">TABLE</router-link>
							</li>
							<li>
								<router-link :to="{ name: 'Supplier Performance Map' }">MAP</router-link>
							</li>
						</ul>
					</nav>
					<div class="supplier-performance-body">
						<router-view />
					</div>
				</v-card>
			</v-container>
			<orixe-footer />
		</VMain>
		<test-error />
	</v-app>
</template>

<script>
export default {
	name: "SupplierPerformanceView",
}
</script>

<style scoped>
.supplier-performance-nav ul {
	margin: 0;
	padding: 16px 0 0;
}

.supplier-performance-shell {
	border-radius: 8px;
	overflow: visible;
}

.supplier-performance-body {
	padding: 0 24px 24px;
}

.supplier-performance-nav li {
	display: inline;
}

.supplier-performance-nav a {
	display: inline-block;
	padding: 0.5em;
	font: inherit;
	margin: 10px;
	text-decoration: none;
	font-weight: bolder;
	color: gray;
}

.supplier-performance-nav a:hover {
	border-bottom: 4px solid #1e7c83;
	font-weight: bolder;
	color: #1e7c83;
}

.main-nav {
	width: auto;
	text-align: center;
	font-size: 1.2em;
}

a.router-link-active {
	border-bottom: 4px solid #1e7c83;
	font-weight: bolder;
	color: #1e7c83;
}
</style>
